module.exports = __webpack_public_path__ + "prod/1.42.2/img/banner_bg.30973c73.jpg";